module.exports = __webpack_public_path__ + "img/undraw_empty_street_sfxm.25b08543.svg";